import React, { useEffect, useState, useRef } from "react";

export default function WebsiteRequestJourney() {
  // --------- Websites list ---------
  const websites = [
    { name: "Example.com", url: "https://www.example.com", ip: "172.217.3.110" },
    { name: "OpenAI.com", url: "https://www.openai.com", ip: "104.18.12.123" },
    { name: "Google.com", url: "https://www.google.com", ip: "172.217.5.110" },
    { name: "GitHub.com", url: "https://www.github.com", ip: "140.82.114.4" },
    { name: "Wikipedia.org", url: "https://www.wikipedia.org", ip: "91.198.174.192" },
  ];

  const [currentSite] = useState(0);
  const [step, setStep] = useState(1);

  // Step 1: URL building
  const [urlDrop, setUrlDrop] = useState("");
  const [urlParts, setUrlParts] = useState([]);
  const [hint1, setHint1] = useState("💡 Hint: A URL usually starts with 'https://'");

  // Step 2: DNS
  const [dnsCorrect, setDnsCorrect] = useState(false);
  const [hint2, setHint2] = useState("💡 DNS finds the server address.");

  // Step 3: Internet Obstacles
  const [clearedObstacles, setClearedObstacles] = useState([]);
  const obstaclesArray = [
    { name: "🔥 Firewall", type: "firewall" },
    { name: "🦠 Virus", type: "virus" },
    { name: "🌉 Broken Bridge", type: "broken" },
    { name: "🔥 Firewall", type: "firewall" },
  ];

  // Step 4: Server Quiz
  const quizQuestions = [
    { q: "Which part stores information?", opts: ["HTML", "CSS", "Database"], ans: "Database" },
    { q: "Which makes the website look colorful?", opts: ["HTML", "CSS", "JS"], ans: "CSS" },
    { q: "Which makes the website interactive?", opts: ["HTML", "CSS", "JS"], ans: "JS" },
  ];
  const [quiz, setQuiz] = useState(quizQuestions[Math.floor(Math.random() * quizQuestions.length)]);
  const [quizCorrect, setQuizCorrect] = useState(false);
  const [hint4, setHint4] = useState("💡 Choose the correct answer to proceed.");

  // Sounds
  const correctSound = useRef(null);
  const wrongSound = useRef(null);
  const clickSound = useRef(null);

  useEffect(() => {
    correctSound.current = new Audio("https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg");
    wrongSound.current = new Audio("https://actions.google.com/sounds/v1/cartoon/boing.ogg");
    clickSound.current = new Audio("https://actions.google.com/sounds/v1/cartoon/pop.ogg");

    // Step1: prepare URL parts
    const correctParts = [
      "https://",
      "www." + websites[currentSite].name.split(".")[0],
      "." + websites[currentSite].name.split(".")[1],
    ];
    const wrongParts = ["wrongpart", "123", "abc"];
    setUrlParts([...correctParts, ...wrongParts].sort(() => Math.random() - 0.5));
  }, []);

  // --------- Step Handlers ---------
  // Step 1: URL drop
  const handleDropUrl = (part) => {
    const correctParts = [
      "https://",
      "www." + websites[currentSite].name.split(".")[0],
      "." + websites[currentSite].name.split(".")[1],
    ];
    const newUrl = urlDrop + part;
    setUrlDrop(newUrl);
    if (newUrl === correctParts.join("")) {
      correctSound.current.play();
      setTimeout(() => setStep(2), 500);
    } else if (newUrl.length > 30) {
      wrongSound.current.play();
      setUrlDrop("");
    }
  };

  // Step 2: DNS
  const handleDnsDrop = (ip) => {
    if (ip === websites[currentSite].ip) {
      correctSound.current.play();
      setDnsCorrect(true);
      setTimeout(() => setStep(3), 500);
    } else {
      wrongSound.current.play();
      setHint2("❌ Try the correct IP!");
    }
  };

  // Step 3: Obstacles
  const handleObstacleClick = (type, idx) => {
    clickSound.current.play();
    if (type === "firewall" || type === "virus") {
      if (!clearedObstacles.includes(idx)) {
        setClearedObstacles([...clearedObstacles, idx]);
        correctSound.current.play();
      }
    } else {
      wrongSound.current.play();
    }
    if (clearedObstacles.length + 1 === 3) setTimeout(() => setStep(4), 500);
  };

  // Step 4: Quiz
  const handleQuizClick = (opt) => {
    clickSound.current.play();
    if (opt === quiz.ans) {
      correctSound.current.play();
      setQuizCorrect(true);
      setTimeout(() => setStep(5), 500);
    } else {
      wrongSound.current.play();
      setHint4("❌ Try again!");
    }
  };

  // Step 5: Visit Website
  const handleVisit = () => {
    window.open(websites[currentSite].url, "_blank");
  };

  // --------- Rendering Steps ---------
  return (
    <div style={{ fontFamily: "Comic Sans MS, cursive", minHeight: "100vh", padding: 20, display: "flex", flexDirection: "column", alignItems: "center", background: "linear-gradient(to bottom, #f0f8ff, #c6f0ff)" }}>
      <h1 style={{ textAlign: "center", marginTop: 20, color: "#333", textShadow: "1px 1px #fff" }}>🌐 Journey of a Website Request 🌐</h1>

      {/* Step 1 */}
      {step === 1 && (
        <div style={{ width: "90%", maxWidth: 900, background: "#fff", borderRadius: 15, padding: 20, boxShadow: "3px 3px 15px rgba(0,0,0,0.2)", margin: "20px 0", textAlign: "center", position: "relative" }}>
          <div style={{ fontSize: 50, margin: "20px auto" }}>💻</div>
          {/* <select  value={selectitem}  ></select> */}
          <p>Step 1: Build the correct URL by dragging parts!</p>
          <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 10 }}>
            {urlParts.map((p) => (
              <span key={p} draggable style={{ padding: "10px 20px", background: "#2196f3", color: "white", borderRadius: 10, cursor: "grab", fontWeight: "bold" }} onDragStart={(e) => e.dataTransfer.setData("text", p)} onDragEnd={() => handleDropUrl(p)}>
                {p}
              </span>
            ))}
          </div>
          <p>URL: <span style={{ display: "inline-block", minWidth: 50, minHeight: 30, border: "2px dashed #333", padding: "5px 10px", borderRadius: 8 }}>{urlDrop}</span></p>
          <p style={{ marginTop: 10, fontSize: 14, fontWeight: "bold", color: "#333" }}>{hint1}</p>
        </div>
      )}

      {/* Step 2 */}
      {step === 2 && (
        <div style={{ width: "90%", maxWidth: 900, background: "#fff", borderRadius: 15, padding: 20, boxShadow: "3px 3px 15px rgba(0,0,0,0.2)", margin: "20px 0", textAlign: "center", position: "relative" }}>
          <div style={{ fontSize: 50, margin: "20px auto" }}>📖</div>
          <p>Step 2: Drag the website to the correct IP address!</p>
          <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
            <span draggable style={{ padding: "10px 20px", background: "#2196f3", color: "white", borderRadius: 10, cursor: "grab", fontWeight: "bold" }} onDragStart={(e) => e.dataTransfer.setData("text", websites[currentSite].name)}>
              {websites[currentSite].name}
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
            {[websites[currentSite].ip, "192.168.0.2", "10.0.0.1"].sort(() => Math.random() - 0.5).map((ip) => (
              <span key={ip} style={{ display: "inline-block", minWidth: 80, minHeight: 40, border: "2px dashed #333", padding: "5px 10px", borderRadius: 8, cursor: "pointer" }} onClick={() => handleDnsDrop(ip)}>
                {ip}
              </span>
            ))}
          </div>
          <p style={{ marginTop: 10, fontSize: 14, fontWeight: "bold", color: "#333" }}>{hint2}</p>
        </div>
      )}

      {/* Step 3 */}
      {step === 3 && (
        <div style={{ width: "90%", maxWidth: 900, background: "#fff", borderRadius: 15, padding: 20, boxShadow: "3px 3px 15px rgba(0,0,0,0.2)", margin: "20px 0", textAlign: "center", position: "relative" }}>
          <div style={{ fontSize: 50, margin: "20px auto" }}>🛣️</div>
          <p>Step 3: Click all obstacles to clear the Internet path!</p>
          <p style={{ marginTop: 10, fontSize: 14, fontWeight: "bold", color: "#333" }}>💡 Click all firewalls and viruses, avoid broken bridges!</p>
          <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 10, marginTop: 20 }}>
            {obstaclesArray.map((o, idx) => (
              <div key={idx} onClick={() => handleObstacleClick(o.type, idx)} style={{ width: 80, height: 80, background: clearedObstacles.includes(idx) ? "#4caf50" : "#f44336", borderRadius: 10, display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontWeight: "bold", cursor: "pointer" }}>
                {o.name}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Step 4 */}
      {step === 4 && (
        <div style={{ width: "90%", maxWidth: 900, background: "#fff", borderRadius: 15, padding: 20, boxShadow: "3px 3px 15px rgba(0,0,0,0.2)", margin: "20px 0", textAlign: "center", position: "relative" }}>
          <div style={{ fontSize: 50, margin: "20px auto" }}>🏠</div>
          <p>{quiz.q}</p>
          <p style={{ marginTop: 10, fontSize: 14, fontWeight: "bold", color: "#333" }}>{hint4}</p>
          <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
            {quiz.opts.map((opt) => (
              <button key={opt} style={{ padding: "10px 20px", borderRadius: 10, cursor: "pointer" }} onClick={() => handleQuizClick(opt)}>
                {opt}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Step 5 */}
      {step === 5 && (
        <div style={{ width: "90%", maxWidth: 900, background: "#fff", borderRadius: 15, padding: 20, boxShadow: "3px 3px 15px rgba(0,0,0,0.2)", margin: "20px 0", textAlign: "center", position: "relative" }}>
          <div style={{ fontSize: 50, margin: "20px auto" }}>💻</div>
          <p>Step 5: Your webpage has arrived!</p>
          <div style={{ marginTop: 20, fontSize: 18, fontWeight: "bold" }}>🌐 Welcome to {websites[currentSite].name}!</div>
          <p>🎉 Congratulations! You've earned the <strong>Web Explorer Badge</strong> 🏅</p>
          <button style={{ padding: "10px 20px", borderRadius: 10, cursor: "pointer" }} onClick={handleVisit}>Visit Website 🌐</button>
        </div>
      )}
    </div>
  );
}
